<div>


  <div>
    <iui-messages id="messages" #messages class="ms-auto me-auto"></iui-messages>
  </div>

  <form #form="ngForm" name="form" (ngSubmit)="submit(form)">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-2">
          <label for="shortCode">Short Code</label>
          <input appAlphaNumOnly appScrText required placeholder="Short Code" type="text" id="shortCode" class="form-control form-text" name="shortCode" #shortCode="ngModel"
            maxlength="{{MaxLen.ShortCode}}" [(ngModel)]="shortCodeValue" [ngClass]="{'error-input': shortCode.errors && form.submitted}" />
        </div>
        <div class="col-2 d-flex" style="align-self: flex-end;">
          <button submit class="btn btn-primary ms-3">Search</button>
        </div>
      </div>
      <div class="row ps-3">
        <app-error-msg [field]="shortCode" [fieldLabel]="'Short Code'" [form]="form"></app-error-msg>
      </div>
    </div>

  </form>

  <div class="row" *ngIf="errorMessage">
    <div class="col-12">
      <h5> <span>{{preErrorMessage}} <span>{{errorDisplayShortCode}}</span>
          {{errorMessage}} </span></h5>
    </div>
    <div class="col-12">
      <a href='javascript:void(0)' (click)='getSCHistory(searchShortCodeValue)'><span>View history about code {{errorDisplayShortCode}}</span>
      </a>
    </div>
  </div>
  <div *ngIf="showData">
    <div class="row">
      <div class="col-12">
        <h4>Lookup Results for {{shortCodeDisplay}}</h4>
      </div>
    </div>
    <div class="row mt-1 mb-4">
      <div class="col-12">
        <a href="javascript:void(0)" (click)="getSCHistory(shortCodeValue)"><span>View history about code {{shortCodeDisplay}}</span> </a>
      </div>
    </div>
    <div class="row mt-1 mb-2">
      <div class="col-4">
        <h5>Summary</h5>
        <div><strong>Short Code:</strong> {{shortCodeDetail.scId}}</div>
        <div><strong>Short Code Status:</strong> {{shortCodeDetail.scStatus}}</div>
        <div><strong>Expiration Date:</strong> {{shortCodeDetail.scExpirationDate | date: 'M/d/yyyy'}}</div>
        <div><strong>Order ID:</strong> {{shortCodeDetail.orderId}}</div>
        <div><strong>Application Type:</strong> {{shortCodeDetail.applicationType}}</div>
        <div><strong>Code Type:</strong> {{shortCodeDetail.selectType}}</div>
        <div><strong>Term:</strong> {{shortCodeDetail.term| termLength: shortCodeDetail.leaseType}}</div>
        <div><strong>Lease Status:</strong> {{shortCodeDetail.leaseStatus| leaseStatus}}</div>
        <div><strong>Auto-Renew:</strong> {{shortCodeDetail.autorenew?'Opted-In':'Opted-Out'}}</div>
        <div><strong>Age Date:</strong> {{shortCodeDetail.ageDate | date: 'M/d/yyyy'}}</div>

      </div>
      <div class="col-4">
        <h5>CSC Registrant Details</h5>
        <div><strong>Contact Name:</strong> {{shortCodeDetail.firstName}} {{shortCodeDetail.lastName}}</div>
        <div class="truncate" [pTooltip]="shortCodeDetail.company" tooltipPosition="top" appShowToolTipIfTruncated><strong>Organization Name:</strong> {{shortCodeDetail.company}}</div>
        <div><strong>Phone:</strong> {{shortCodeDetail.phone | phoneNumber }} </div>
        <div><strong>Extension: </strong> {{shortCodeDetail.phoneExtension}}</div>
        <div class="truncate" [pTooltip]="shortCodeDetail.email" tooltipPosition="top" appShowToolTipIfTruncated><strong>Email Address:</strong> {{shortCodeDetail.email}}
        </div>
        <div class="truncate" [pTooltip]="shortCodeDetail.address1" tooltipPosition="top" appShowToolTipIfTruncated><strong>Address 1:</strong> {{shortCodeDetail.address1}}</div>
        <div class="truncate" [pTooltip]="shortCodeDetail.address2" tooltipPosition="top" appShowToolTipIfTruncated><strong>Address 2:</strong> {{shortCodeDetail.address2}}</div>
        <div class="truncate" [pTooltip]="shortCodeDetail.city" appShowToolTipIfTruncated><strong>City:</strong> {{shortCodeDetail.city}}</div>
        <div><strong>State/Province:</strong> {{shortCodeDetail.state}}</div>
        <div><strong>Zip/Postal Code:</strong> {{shortCodeDetail.zip}}</div>
        <div><strong>Country:</strong> {{shortCodeDetail.country | scrConfig:'country'}}</div>
      </div>
      <div class="col-4">
        <h5>Billing Contact Details</h5>
        <div><strong>Contact Name:</strong> {{shortCodeDetail.billingFirstName}}
          {{shortCodeDetail.billingLastName}}</div>
        <div><strong>Phone:</strong> {{shortCodeDetail.billingPhone | phoneNumber }} </div>
        <div><strong>Extension: </strong> {{shortCodeDetail.billingPhoneExtension}}</div>
        <div class="truncate" [pTooltip]="shortCodeDetail.billingEmail" tooltipPosition="top" appShowToolTipIfTruncated><strong>Email Address:</strong>
          {{shortCodeDetail.billingEmail}}</div>
        <div class="truncate" [pTooltip]="shortCodeDetail.billingAddress1" tooltipPosition="top" appShowToolTipIfTruncated><strong>Address 1:</strong>
          {{shortCodeDetail.billingAddress1}}</div>
        <div class="truncate" [pTooltip]="shortCodeDetail.billingAddress2" tooltipPosition="top" appShowToolTipIfTruncated><strong>Address 2:</strong>
          {{shortCodeDetail.billingAddress2}}</div>
        <div class="truncate" [pTooltip]="shortCodeDetail.billingCity" tooltipPosition="top" appShowToolTipIfTruncated><strong>City:</strong> {{shortCodeDetail.billingCity}}</div>
        <div><strong>State/Province:</strong> {{shortCodeDetail.billingState}}</div>
        <div><strong>Zip/Postal Code:</strong> {{shortCodeDetail.billingZip}}</div>
        <div><strong>Country:</strong> {{shortCodeDetail.billingCountry | scrConfig:'country'}}</div>
      </div>

    </div>

    <div class="row mt-4 mb-2">
      <div class="col-4">
        <h5>Content Provider</h5>

        <div class="me-3"><strong>Content Provider ID: </strong><span *ngIf="shortCodeDetail.cpId">{{shortCodeDetail.contentProvider?.partnerId}}</span></div>
        <div class="me-3 truncate" [pTooltip]="shortCodeDetail.contentProvider?.company" tooltipPosition="top" appShowToolTipIfTruncated>
          <strong>Organization Name: </strong><span *ngIf="shortCodeDetail.cpId">{{shortCodeDetail.contentProvider?.company}}</span>
        </div>
        <div class="me-3"><strong>FEIN: </strong><span *ngIf="shortCodeDetail.cpId">{{shortCodeDetail.contentProvider?.fein}}</span></div>
        <div class="me-3"><strong>URL: </strong><span *ngIf="shortCodeDetail.cpId">{{shortCodeDetail.contentProvider?.companyUrl}}</span></div>

        <div class="me-3"><strong>Contact Name: </strong><span *ngIf="shortCodeDetail.cpId">{{shortCodeDetail.contentProvider?.firstName}} {{shortCodeDetail.contentProvider?.lastName}}</span></div>
        <div class="me-3"><strong>Phone: </strong><span *ngIf="shortCodeDetail.cpId">{{shortCodeDetail.contentProvider?.phone | phoneNumber }}</span></div>
        <div class="me-3"><strong>Extension: </strong><span *ngIf="shortCodeDetail.cpId">{{shortCodeDetail.contentProvider?.phoneExtension}}</span></div>
        <div class="me-3 truncate" [pTooltip]="shortCodeDetail.contentProvider?.email" tooltipPosition="top" appShowToolTipIfTruncated>
          <strong>Email Address: </strong><span *ngIf="shortCodeDetail.cpId">{{shortCodeDetail.contentProvider?.email}}</span>
        </div>
        <div class="me-3"><strong>Vet Status Date: </strong><span *ngIf="shortCodeDetail.cpId">{{shortCodeDetail.contentProvider?.vetStatusUpdateTime | date:'M/d/yyyy h:mm:ss a' }}</span></div>
        <div class="me-3"><strong>Vet Status: </strong><span *ngIf="shortCodeDetail.cpId">{{shortCodeDetail.contentProvider?.vetStatus}}</span></div>
        <div class="me-3"><strong>Vet Results: </strong>
        @if (showViewResultsLink(shortCodeDetail.contentProvider)) {
          <a *ngIf="shortCodeDetail.cpId" href="" (click)="viewVetResults($event, shortCodeDetail.contentProvider)">View</a>
          }
        </div>

      </div>

      <div class="col-4">
        <h5>Political Campaign Details</h5>
        <div><strong>Political Campaign:</strong> {{shortCodeDetail.forPoliticalCampaign? 'Yes': 'No'}}</div>
        <div><strong>Political Campaign Status:</strong> {{shortCodeDetail.politicalCampaignStatus }} </div>
        <div class="truncate" [pTooltip]="shortCodeDetail.politicalCampaignComments" tooltipPosition="top" appShowToolTipIfTruncated><strong>Comments:</strong>
          {{shortCodeDetail.politicalCampaignComments}}</div>
        <div><strong>Campaign Type:</strong> {{shortCodeDetail.politicalCampaignType}} </div>
        <div><strong>FEC ID:</strong> {{shortCodeDetail.fecId}} </div>
        <div><strong>Other Campaign Info:</strong> {{shortCodeDetail.politicalCampaignInfo}} </div>
      </div>

      <div class="col-4">
        <div>
          <h5 i18n>Direct Connection Aggregator</h5>
          <div>{{shortCodeDetail.aggregatorName}}</div>
        </div>

        <div style="padding-top: 1rem;">
          <h5 i18n>Application Service Provider</h5>
          <div>{{shortCodeDetail.applicationProvider}}</div>
        </div>
      </div>
    </div>
    <div class="row mt-4 mb-2">
      <div class="col-8">
        <h5>Brand Client(s)</h5>
        @if (shortCodeDetail.parkedCode) {
        <div>No Brand Client - Parked Code</div>
        }
        @if (shortCodeDetail.demoCode) {
        <div>No Brand Client - Demo Code</div>
        }
        @if (!shortCodeDetail.parkedCode && !shortCodeDetail.demoCode) {
        <p-table styleClass="p-datatable-striped" [value]="shortCodeDetail.brands!" [sortOrder]="1" sortField="company" [scrollable]="true" scrollHeight="50vh">
          <ng-template pTemplate="header" let-columns>
            <tr *ngIf="shortCodeDetail?.brands?.length">
              <th>Brand ID</th>
              <th class="noBorder" [style.width.%]="50" [pSortableColumn]="'company'">Brand Client Organization Name<p-sortIcon [field]="'company'"></p-sortIcon></th>
              <th>FEIN</th>
              <th>Vet Status</th>
              <th>Vet Results</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowIndex="rowIndex" let-brand>
            <tr>
              <td class="noBorder">{{brand.partnerId}}</td>
              <td class="noBorder">{{brand.company}}</td>
              <td class="noBorder">{{brand.fein}}</td>
              <td class="noBorder">{{brand.vetStatus}}</td>
              <td class="noBorder">
                @if (showViewResultsLink(brand)) {
                  <a href="" (click)="viewVetResults($event, brand)">View</a>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            There are no Brand Clients currently associated with this short code.
          </ng-template>
        </p-table>
        }
      </div>
    </div>

  </div>


</div>

<app-dynamic-dialog (whenComplete)="onDialogComplete($event)"></app-dynamic-dialog>
